import { endpoints } from '../Constants';
import { authHeader } from '../Helpers';
import handleResponse from './helpers';

const modulesConfiguration = {
	getModulesConfiguration,
	updateModulesConfiguration,
};

function getModulesConfiguration() {
	const requestOptions = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
	};
	return fetch(endpoints.GET_MODULES_CONFIGURATION, requestOptions)
		.then(handleResponse);
}

function updateModulesConfiguration(req) {
	const requestOptions = {
		method: 'POST',
		body: JSON.stringify({
			...req.data,
		}),
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
	};
	return fetch(endpoints.UPDATE_MODULES_CONFIGURATION, requestOptions)
		.then(handleResponse);
}

export default modulesConfiguration;
